import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ComboTheme } from '@euler/lib/charts/ComboChart/types';
import { useMemo } from 'react';

/** The chart's text and line colors, from the chart widget's look. */
export function useBiChartTheme(): ComboTheme {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () => ({
      axisText: '#94A3B8',
      axisTitle: '#64748B',
      axisLine: '#CBD5E1',
      grid: '#E2E8F0',
      label: '#475569',
      background: '#FFFFFF',
      fontFamily: FontFamily.NotoSans.Regular,
      fontSize: rpx(10),
    }),
    [rpx],
  );
}
